import Cookies from 'js-cookie';
import styled from 'styled-components';

import { Button } from '@hivebrite/design-system/Button';
import { DefaultLink } from '@hivebrite/design-system/Link';

import CustomContentBox from 'hb-react/publicoffice/apps/LoginApp/utils/CustomContentBox';

import { METHODS, setAuthAttempt } from '../utils/authAttemptSessionStorage';

const LoginSso = ({ settings, origin }) => {
  const {
    accessibility_label: accessibilityLabel,
    button_text: buttonText,
    enabled,
    tagline,
    url,
  } = settings;

  let urlWithRedirect;

  if (url && origin) {
    urlWithRedirect = new URL(url);
    urlWithRedirect.searchParams.append('redirect_to', origin);
    urlWithRedirect = urlWithRedirect.toString();
  }

  return enabled ? (
    <>
      {tagline && (
        <CustomContentBox
          mt={3}
          mb={2}
          display="block"
          dangerouslySetInnerHTML={{ __html: tagline }}
        />
      )}
      <DefaultLink href={urlWithRedirect ?? url}>
        <CustomButton
          aria-label={accessibilityLabel}
          data-provider="sso"
          onClick={() => {
            const cookiesConsentListData = Cookies.get(
              'cookie_consent_list_fo',
            );

            if (cookiesConsentListData) {
              const cookiesConsentList = JSON.parse(cookiesConsentListData);

              if (
                cookiesConsentList.tracking?.find(
                  (cookie) => cookie.name === 'Google analytics',
                )?.accepted
              ) {
                Cookies.set('login_method', 'sso', { expires: 1 });
              }
            }
            setAuthAttempt(METHODS.SSO);
          }}
        >
          {buttonText}
        </CustomButton>
      </DefaultLink>
    </>
  ) : null;
};

export default LoginSso;

const CustomButton = styled(Button)`
  height: 36px;
  margin-top: 12px;
  width: 100%;
`;
